import { isArray, isEmpty, isError, isNull, isObject } from "../../utils/is.js";
import { deepEqual } from "../../utils/deepEqual.js";
import { getCurrentTimestamp, timestampToIsoString } from "../../utils/date.js";
import { stringifyExternalJson, stringifyObjectValues } from "../../utils/json.js";
import { captureMetas } from "../../metas/capture.js";
import _objectSpread2 from "../../_virtual/_@oxc-project_runtime@0.143.0/helpers/esm/objectSpread2.js";
import "../../transports/const.js";
import { addItemToUserActionBuffer } from "../userActions/initialize.js";
import "./const.js";
import { shouldIgnoreEvent } from "../utils.js";
//#region src/api/exceptions/initialize.ts
let stacktraceParser;
function initializeExceptionsAPI({ internalLogger, config, metas, transports, tracesApi, userActionsApi }) {
	var _config$parseStacktra;
	internalLogger.debug("Initializing exceptions API");
	let lastPayload = null;
	stacktraceParser = (_config$parseStacktra = config.parseStacktrace) !== null && _config$parseStacktra !== void 0 ? _config$parseStacktra : stacktraceParser;
	const changeStacktraceParser = (newStacktraceParser) => {
		internalLogger.debug("Changing stacktrace parser");
		stacktraceParser = newStacktraceParser !== null && newStacktraceParser !== void 0 ? newStacktraceParser : stacktraceParser;
	};
	const getStacktraceParser = () => stacktraceParser;
	const { ignoreErrors = [], preserveOriginalError } = config;
	const pushError = (error, { skipDedupe, stackFrames, type, context, spanContext, timestampOverwriteMs, originalError, fingerprint, fatal } = {}) => {
		if (isErrorIgnored(ignoreErrors, originalError !== null && originalError !== void 0 ? originalError : error)) return;
		try {
			var _stackFrames, _payload$fatal;
			const ctx = stringifyObjectValues(_objectSpread2(_objectSpread2({}, parseCause(originalError !== null && originalError !== void 0 ? originalError : error)), context !== null && context !== void 0 ? context : {}));
			const payload = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
				type: type || error.name || "Error",
				value: error.message,
				timestamp: timestampOverwriteMs ? timestampToIsoString(timestampOverwriteMs) : getCurrentTimestamp(),
				trace: spanContext ? {
					trace_id: spanContext.traceId,
					span_id: spanContext.spanId
				} : tracesApi.getTraceContext()
			}, isEmpty(ctx) ? {} : { context: ctx }), preserveOriginalError ? { originalError } : {}), fingerprint ? { fingerprint } : {}), fatal !== void 0 ? { fatal } : {});
			stackFrames = (_stackFrames = stackFrames) !== null && _stackFrames !== void 0 ? _stackFrames : error.stack ? stacktraceParser === null || stacktraceParser === void 0 ? void 0 : stacktraceParser(error).frames : void 0;
			if (stackFrames === null || stackFrames === void 0 ? void 0 : stackFrames.length) payload.stacktrace = { frames: stackFrames };
			const testingPayload = {
				type: payload.type,
				value: payload.value,
				stacktrace: payload.stacktrace,
				context: payload.context,
				fingerprint: payload.fingerprint,
				fatal: (_payload$fatal = payload.fatal) !== null && _payload$fatal !== void 0 ? _payload$fatal : false
			};
			if (!skipDedupe && config.dedupe && !isNull(lastPayload) && deepEqual(testingPayload, lastPayload)) {
				internalLogger.debug("Skipping error push because it is the same as the last one\n", payload);
				return;
			}
			const previousPayload = lastPayload;
			const meta = captureMetas(metas);
			if (lastPayload !== previousPayload && !skipDedupe && config.dedupe && deepEqual(testingPayload, lastPayload)) return;
			lastPayload = testingPayload;
			const item = {
				meta,
				payload,
				type: "exception"
			};
			internalLogger.debug("Pushing exception\n", item);
			if (!addItemToUserActionBuffer(userActionsApi.getActiveUserAction(), item)) transports.execute(item);
		} catch (err) {
			internalLogger.error("Error pushing event", err);
		}
	};
	changeStacktraceParser(config.parseStacktrace);
	return {
		changeStacktraceParser,
		getStacktraceParser,
		pushError
	};
}
function parseCause(error) {
	let cause = error.cause;
	if (isError(cause)) cause = error.cause.toString();
	else if (cause !== null && (isObject(error.cause) || isArray(error.cause))) cause = stringifyExternalJson(error.cause);
	else if (cause != null) cause = error.cause.toString();
	return cause == null ? {} : { cause };
}
function isErrorIgnored(ignoreErrors, error) {
	const { message, name, stack } = error;
	return shouldIgnoreEvent(ignoreErrors, message + " " + name + " " + stack);
}
//#endregion
export { initializeExceptionsAPI };

//# sourceMappingURL=initialize.js.map